export default {
    isAuthenticated({ authUser }) {
        return authUser && authUser.email;
    },
};
